// pipe para localdatetime
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'localDateTime'
})
export class LocalDateTimePipe implements PipeTransform {
  constructor(private datePipe: DatePipe) { }

  transform(value: any, format: string = 'dd/MM/yyyy'): string {
    if (!value) return '';

    let date: Date;

    // Si es array tipo [2027,7,7,0,0]
    if (Array.isArray(value) && value.length >= 3) {
      const [year, month, day, hour = 0, minute = 0] = value;
      date = new Date(year, month - 1, day, hour, minute);
    }

    // Si es string tipo '2027-07-07T00:00:00'
    else if (typeof value === 'string' && value.includes('T')) {
      date = new Date(value);
    }

    // Si es un número (timestamp en milisegundos)
    else if (typeof value === 'number') {
      date = new Date(value);
    }

    // Si ya es Date
    else if (value instanceof Date) {
      date = value;
    }

    // Si no se puede interpretar
    else {
      return '';
    }

    return this.datePipe.transform(date, format) || '';
  }
}


// localDateTime:'dd/MM/yyyy HH:mm'
// localDateTime:'fullDate'
// localDateTime:'MMM d, y, h:mm a'
